import LayersIcon from "@mui/icons-material/Layers";
import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material";
import api from "app/api";
import { globalMessageHandler } from "common";
import { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { ScheduleContext } from "../ScheduleTabs";

export default function ActivateEventsButton() {
  const context = useContext(ScheduleContext);
  const params = useParams<"schedule_id">();
  const [loading, setLoading] = useState(false);

  async function activateEvents() {
    globalMessageHandler.confirm(
      {
        message: "Biztosan aktiválod az összes eseményt?",
      },
      async () => {
        setLoading(true);
        const { success, data, error } = await api.post(
          `/schedules/${params?.schedule_id}/activate-events`
        );
        setLoading(false);
        if (success) {
          context?.load && context?.load();
          globalMessageHandler.snack({
            severity: "success",
            message: `Sikeresen aktiválva. ${data.count} esemény.`,
          });
        } else {
          globalMessageHandler.snack({
            severity: "error",
            message: error?.message,
          });
        }
      }
    );
  }

  return (
    <Tooltip title={"Események Aktiválása"}>
      <Box>
        <IconButton
          color="success"
          onClick={activateEvents}
          disabled={
            !!(context?.isCreate || context?.loading || context?.isDirty) ||
            !context?.item?.has_event
          }
        >
          {loading ? <CircularProgress size={16} /> : <LayersIcon />}
        </IconButton>
      </Box>
    </Tooltip>
  );
}
